import './OrganizationTree.css';

function AboutOrganization() {
  return (
    <div className="tree-container">
      <h2>조직도</h2>
      <div className="tree">
        <ul>
          <li>
            <div className="box">대표이사</div>
            <ul>
              <li>
                <div className="box">R&D</div>
                <ul>
                  <li><div className="box">개발1팀</div></li>
                  <li><div className="box">개발2팀</div></li>
                </ul>
              </li>
              <li>
                <div className="box">제조부</div>
                <ul>
                  <li><div className="box">생산1팀</div></li>
                  <li><div className="box">생산2팀</div></li>
                </ul>
              </li>
              <li>
                <div className="box">경영지원부</div>
                <ul>
                  <li><div className="box">인사팀</div></li>
                  <li><div className="box">회계팀</div></li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AboutOrganization;
